/**
 * Centralized API Configuration
 * 
 * Handles determination of the Backend API URL based on environment.
 * Prevents production builds from defaulting to 'localhost'.
 */

// Explicitly configured URL from Environment Variables (preferred)
const ENV_API_URL = import.meta.env.VITE_API_BASE_URL;

// Detection of Localhost (Browser Environment)
const isLocalhost = typeof window !== 'undefined' && (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname.includes('192.168')
);

/**
 * Determines the best API Base URL.
 * 
 * Strategy:
 * 1. If VITE_API_BASE_URL is set -> Use it.
 * 2. If running on Localhost -> Default to http://localhost:8080.
 * 3. If running in Production (Remote) -> Default to same-origin relative path ('/').
 *    This allows Nginx proxies or same-domain deployments to work automatically.
 *    It PREVENTS trying to hit localhost from a production URL.
 */
export const getApiBaseUrl = (): string => {
    if (ENV_API_URL) {
        return ENV_API_URL;
    }

    if (isLocalhost) {
        return 'http://localhost:8080';
    }

    // Default to relative path for production if no env var is provided.
    // This allows the frontend to hit /api directly on the same domain.
    // If the backend is on a different domain, VITE_API_BASE_URL *MUST* be set.
    return '';
};

export const API_CONFIG = {
    baseURL: getApiBaseUrl(),
    timeout: 30000, // 30s timeout
};
